import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import useStyles from './styles';
import { AssociatedVendor } from '.';
import { useStore } from 'src/stores';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { Button, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import useModalFooterStyles from 'src/styles/cutomModalFooter';
import { BackdropLoader, toast } from '@livable/saas-react-components';
export const AssociatedVendorModalContent = observer(_ref => {
  let handleModalClose = _ref.handleModalClose,
    utilityProviderId = _ref.utilityProviderId,
    forceUpdate = _ref.forceUpdate;
  const store = useStore();
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const modalFooterClasses = useModalFooterStyles();
  const _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    isForm = _useState2[0],
    setIsForm = _useState2[1];
  const handleSave = async () => {
    if (store.vendors.tempData.vendorExternalId) {
      const associateResp = await store.vendors.associateVendorsAsync.run({
        utilityProviderLivableId: utilityProviderId,
        vendorExternalId: store.vendors.tempData.vendorExternalId
      });
      if (associateResp && associateResp !== null && associateResp !== void 0 && associateResp.isSuccessful) {
        await store.vendors.getVendorsByUtilityProviderIdAsync.run({
          utilityProviderId: utilityProviderId
        });
        if (forceUpdate) forceUpdate();
      }
    }
    toast('success', {
      body: ['Successfully saved']
    });
    handleModalClose();
  };
  useEffect(() => {
    if (utilityProviderId) {
      store.vendors.getVendorsByUtilityProviderIdAsync.run({
        utilityProviderId
      });
    }
    return () => {
      store.vendors.changeTempDataVendor(null);
      store.vendors.changeTempDataProperty(null);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, isForm && /*#__PURE__*/React.createElement("div", {
    className: classes.modalForm
  }, /*#__PURE__*/React.createElement(AssociatedVendor, {
    utilityProviderId: utilityProviderId,
    isModal: true
  })), !isForm && /*#__PURE__*/React.createElement("div", {
    className: classes.modalWarning
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, t('add_new_property_flow.you_are_about_to_change_associated_vendor')), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2"
  }, t('add_new_property_flow.this_will_replace_the_current_vendor'))), /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.modalFooterStandart
  }, /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerEven
  }, /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerWrapper
  }, /*#__PURE__*/React.createElement(Button, {
    disabled: store.vendors.associateVendorsAsync.inProgress,
    variant: "text",
    onClick: () => handleModalClose()
  }, t('Cancel'))), !isForm && /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerButton
  }, /*#__PURE__*/React.createElement(Button, {
    disabled: store.vendors.associateVendorsAsync.inProgress,
    onClick: handleSave,
    type: "button",
    variant: "contained"
  }, t('Change')))), isForm && /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerButton
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: () => setIsForm(false),
    type: "button",
    variant: "contained"
  }, t('Save')))))), /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: store.vendors.associateVendorsAsync.inProgress
  }));
});